import { MY_DRAFTS } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = MY_DRAFTS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    numbers: {
        key: 'draftsCount',
        default: 0,
    },
    method: 'addSection',
    social: false,
    showInLoginMenu: true,
    urlOverride: 'my-drafts',
    menuOrder: 2,
    visibleForRoles: ['admin', 'blog_writer', 'blog_editor'],
    page: {
        name: t('member-pages.drafts.name'),
        shortDescription: t('member-pages.drafts.short-description'),
        description: formatDescription({
            text: t('member-pages.drafts.description.text'),
            bulletPoints: [
                t('member-pages.drafts.description.bullet-point-1'),
                t('member-pages.drafts.description.bullet-point-2'),
                t('member-pages.drafts.description.bullet-point-3'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/blog-icon.png`,
        origin: t('member-pages.origin'),
        isNew: false,
        screenshots: [
            `${staticsUrl}assets/images/my-drafts/my-drafts.png`,
            `${staticsUrl}assets/images/my-drafts/mobile-my-drafts.png`,
        ],
    },
});
//# sourceMappingURL=my-drafts.js.map